import React, { useEffect, useState } from 'react';
import { getRequest, deleteRequest } from 'apis/ApiInstence';
import AdminTable from 'common/AdminTable';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

const ListPrograms = () => {
    const [programs, setPrograms] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchPrograms = async () => {
        try {
            setLoading(true);
            const res = await getRequest('programs?all=true');
            setPrograms(res?.data || []);
        } catch (err) {
            console.error('Failed to fetch programs:', err);
            toast.error("Failed to load programs list.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this program?")) {
            try {
                await deleteRequest(`programs/${id}`);
                toast.success("Program deleted successfully!");
                fetchPrograms(); // Refresh list
            } catch (err) {
                console.error(err);
                toast.error("Failed to delete program.");
            }
        }
    };

    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Image',
            accessor: 'image',
            Cell: ({ row }) => (
                row.original.image ? (
                    <img
                        src={`${process.env.REACT_APP_BACKEND}uploads/${row.original.image}`}
                        alt="program"
                        width={70}
                        height={50}
                        style={{ objectFit: 'cover', borderRadius: '4px' }}
                    />
                ) : (
                    <div style={{
                        width: '70px',
                        height: '50px',
                        borderRadius: '4px',
                        backgroundColor: '#ccc',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        fontSize: '11px'
                    }}>
                        No Image
                    </div>
                )
            ),
        },
        {
            Header: 'Program Title',
            accessor: 'title',
            Cell: ({ row }) => (
                <div className="text-left font-weight-bold">
                    {row.original.title}
                </div>
            )
        },
        {
            Header: 'Description',
            accessor: 'description',
            Cell: ({ row }) => (
                <div className="text-left" style={{ fontSize: '13px', maxHeight: '60px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {row.original.description}
                </div>
            )
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <div className="d-flex justify-content-center">
                    <Link
                        className="btn btn-sm btn-info mr-2"
                        to={`/programs/update/${row.original.id}`}
                    >
                        Edit
                    </Link>
                    <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(row.original.id)}
                    >
                        Delete
                    </button>
                </div>
            ),
        }
    ];

    useEffect(() => {
        fetchPrograms();
    }, []);

    return (
        <>
            <div className="container-fluid mt-4">
                {/* Premium Animated Header Banner */}
                <div 
                    className="dashboard-header-card d-flex align-items-center justify-content-between mb-4 mx-2 shadow-lg" 
                    style={{ 
                        background: 'linear-gradient(135deg, #0d47a1 0%, #00695c 100%)', 
                        padding: '1.5rem 2rem', 
                        borderRadius: '15px',
                        animation: 'fadeInUp 0.6s ease-out forwards'
                    }}
                >
                    <div className="d-flex align-items-center">
                        <div className="icon-circle mr-3" style={{ background: 'rgba(255,255,255,0.2)', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <i className="fa fa-briefcase text-white" style={{ fontSize: '24px' }}></i>
                        </div>
                        <div>
                            <h3 className="text-white font-weight-bold mb-0" style={{ letterSpacing: '0.5px' }}>Incubation Programs</h3>
                            <p className="text-white-50 mb-0 small">Manage your startup incubation programs</p>
                        </div>
                    </div>
                    <Link 
                        className="btn btn-light font-weight-bold shadow-sm" 
                        to="/programs/add"
                        style={{ color: '#0d47a1', borderRadius: '8px', padding: '10px 20px', transition: 'all 0.3s' }}
                        onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 5px 15px rgba(255,255,255,0.3)'; }} onFocus={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 5px 15px rgba(255,255,255,0.3)'; }}
                        onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }} onBlur={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
                    >
                        <i className="fa fa-plus mr-2"></i>
                        Add New Program
                    </Link>
                </div>
                
                {loading ? (
                    <div className="text-center my-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                ) : programs.length > 0 ? (
                    <AdminTable tableHeaders={tableHeaders} tableData={programs} />
                ) : (
                    <div className="text-center my-5">
                        <p>No programs created yet.</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default ListPrograms;
